import { StaticImage } from "gatsby-plugin-image"
import * as React from "react"
import { PopupButton } from "react-calendly"

export const VisualFolioResource = () => {
  const [theme, setTheme] = React.useState<string | null>("")
  React.useEffect(() => {
    const interval = setInterval(() => {
      const currentTheme = localStorage.getItem("theme")
      setTheme(currentTheme)
    }, 500)

    return () => clearInterval(interval)
  }, [])
  const [rootElement, setRootElement] = React.useState<HTMLElement | null>(null)

  React.useEffect(() => {
    if (typeof window !== "undefined") {
      const element = document.getElementById("___gatsby")
      setRootElement(element)
    }
  }, [])
  return (
    <>
      <div className="relative lg:bottom-16 lg:mt-0 lg:pb-10 lg:pt-5">
        <div className="container mx-auto w-[70%]">
          <p className="lg:text-4xl sm:text-[18px] text-nowrap text-[10px] text-black font-semibold text-center">
            Why{" "}
            <span className="text-gradient-secondary">
              Visual Folio Resource?
            </span>
          </p>
          <div className="lg:my-4 my-2 w-full">
            <p className="text-center text-black lg:text-sm text-[7px]">
              Visual folio assure the quality of work in all the niches and
              category and provide the resource on their own behalf with the
              project manager who engage with you and developer or designer who
              is work with your team or in a company. All of our resources is
              available here in under one roof. We check all the updates with
              our self as well and monitor the progress of your work with our
              resource.
            </p>
          </div>

          <div className="flex justify-center">
            {rootElement && (
              <PopupButton
                className="px-4 py-3 bg-header-unique-btn text-black font-inter lg:text-sm text-[7px] whitespace-nowrap font-semibold shadow-3xl hover:opacity-70 transition duration-100 ease-in book-free-consultancy-radius bg-btn bg-glass"
                url="https://calendly.com/visualfolio-info/30min"
                rootElement={rootElement}
                text=" Hire Our Expert"
              />
            )}
          </div>
        </div>
        <div className="container mx-auto mt-16 lg:mb-0 mb-10">
          <div className="flex justify-center items-center">
            <div className="w-1/2 relative lg:left-16 left-10 z-10">
              <div>
                <div
                  className={` lg:px-8 lg:py-6 px-1 py-2 rounded-xl ${theme == "glassy" ? "bg-btn bg-[#FFECD5] border-2 border-[#F0CB9E] rounded-xl" : theme === "light" ? "bg-btn bg-[#E6E9EF]" : theme === "dark" ? "bg-btn bg-primary-shadow-dark bg-[#2D3135]" : "bg-btn bg-[#FFECD5] border-2 border-[#F0CB9E]"}`}
                >
                  <p className="text-purple lg:text-lg text-[8px] font-semibold">Discover</p>
                  <p className="text-black font-semibold lg:text-2xl text-[8px] text-nowrap tracking-wider lg:pt-3">
                    Visual folio workforce Under <br /> one roof
                  </p>
                  <div className="w-10 h-[2px] rounded-lg bg-linear-gradient lg:mt-3 mt-1"></div>
                  <p className="text-gray lg:text-sm text-[5px] lg:pt-2 pt-1">
                    At Visual Folio, our dedicated team works seamlessly under
                    one roof to ensure efficiency, quality, and excellence. We
                    take care of every detail, so you get top-tier results from
                    our expert resources delivering innovation, precision, and
                    success in every project!
                  </p>
                </div>
                <div
                  className={` lg:px-8 lg:py-6 px-1 py-2 rounded-xl mt-5 ${theme == "glassy" ? "bg-btn bg-[#FFECD5] border-2 border-[#F0CB9E] rounded-xl" : theme === "light" ? "bg-btn bg-[#E6E9EF]" : theme === "dark" ? "bg-btn bg-primary-shadow-dark bg-[#2D3135]" : "bg-btn bg-[#FFECD5] border-2 border-[#F0CB9E]"}`}
                >
                  {/* <p className="text-purple font-semibold">Discover</p> */}
                  <p className="text-black font-semibold lg:text-2xl text-[8px] tracking-wider pt-2">
                    Anonymity & Privacy at Visual Folio Workforce
                  </p>
                  <div className="w-10 h-[2px] rounded-lg bg-linear-gradient lg:mt-3 mt-1"></div>
                  <p className="text-gray lg:text-sm text-[5px] lg:pt-2 pt-1">
                    At Visual Folio, we respect and prioritize the anonymity and
                    privacy of our workforce and clients. Our team operates with
                    professionalism and discretion, ensuring that projects are
                    handled securely while maintaining confidentiality. Whether
                    through NDAs or secure workflows, your ideas and business
                    remain protected with us.
                  </p>
                </div>
              </div>
            </div>
            <div className="w-[60%]">
              <StaticImage
                className="mx-3 lg:mx-0"
                src="./resources.png"
                alt="resourceHero"
                placeholder="blurred"
                layout="fullWidth"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
